<template>
  <WhiteIQOS :systemDependency="'delivery'" bodyClass="gap-row-sm">
    <div class="gap-column-sm">
      <div class="gap-row-1xs w-100">
        <div class="qrw-heading-xs bold">
          {{ $t('delivery.min_check.title') }}
        </div>
        <div class="qrw-paragraph-md qrw-text-content-base-secondary">
          {{ $t("delivery.min_check.off_desc") }}
        </div>
      </div>
      <BaseBetaToggle v-model="is_active" />
    </div>
    <!-- <BaseInput class="w-100" readonly :value="`${min_check} ${currency.code}`" v-if="!editing"/> -->
    <BaseUnitInput class="w-100" size="md" fullWidth @blur="onEditFinish" type="number" :valid="!!min_check"
      v-model.number="min_check" :unitPlaceholder="currency.symbol" v-if="is_active" />
    <BaseDivider color="border-base-tertiary" />

    <div class="gap-column-sm">
      <div class="gap-row-1xs w-100">
        <div class="qrw-heading-xs bold">
          {{ $t('delivery.max_check.title') }}
        </div>
        <div class="qrw-paragraph-md qrw-text-content-base-secondary">
          {{ $t("delivery.max_check.desc") }}
        </div>
      </div>
      <BaseBetaToggle v-model="is_max_active" />
    </div>

    <BaseUnitInput class="w-100" size="md" fullWidth @blur="onEditFinish" type="number" :valid="!!cost_max_check"
      v-model.number="cost_max_check" :unitPlaceholder="currency.symbol" v-if="is_max_active" />
  </WhiteIQOS>
</template>

<script>
import WhiteIQOS from "@/components/base/WhiteIQOS.vue";

export default {
  data () {
    return {
      editing: false,

      min_check: 0,
      cost_max_check: 0,

      is_active: false,
      is_max_active: false,
    };
  },
  components: {
    WhiteIQOS
  },
  watch: {
    is_active () {
      if (!this.is_active) {
        this.min_check = 0;
        this.onEditFinish();
      }
    },
    is_max_active () {

      if (!this.is_max_active) {
        this.cost_max_check = 0;
        this.onEditFinish();
      }
    }
  },
  methods: {
    showEditUI () {
      this.editing = true;
    },
    hideEditUI () {
      this.editing = false;
      this.setInitialValue();
    },
    onEditFinish () {
      this.$store.commit("setDeliveryMinCheck", this.min_check);
      this.$store.commit('setDeliveryCostMinCheck', this.cost_max_check); //WTF? well, max check is a better name, but still
      this.$store.dispatch("saveCafe");

      // this.editing = false;
    },
    setInitialValue () {
      if (this.cafe.delivery.min_check) {
        this.min_check = this.cafe.delivery.min_check;
      } else {
        this.min_check = 0;
      }

      if (this.cafe.delivery.cost_min_check) {
        this.cost_max_check = this.cafe.delivery.cost_min_check;
      } else {
        this.cost_max_check = 0;
      }

      this.is_active = this.min_check > 0;
      this.is_max_active = this.cost_max_check > 0;
    },
  },
  mounted () {
    this.setInitialValue();
  },
  computed: {
    cafe () {
      return this.$store.state.cafe;
    },
    currency () {
      return this.$store.state.currency;
    },
  },
};
</script>

<style scoped></style>